<template>
  <div class="course-list">
    <div style="
    background-color: #000;
    -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
    background-color: rgba(0,0,0,0.3);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: none;
    z-index: 2;
    opacity: 1.07;
    display: block;
"
         v-if="phoneFilter"
         @click="triggerPhoneFilter()"></div>
    <!-- 课程列表 -->
    <div id="classList">
      <div class="phone-trigger"
           @click="triggerPhoneFilter()">
        <div>
          <span @click="changeOnlineState('live')"
                class="phone_navcheck"
                :class="online?'phone_nav_checked':''">线上直播</span>
          <span @click="changeOnlineState('offline')"
                class="phone_navcheck"
                :class="!online?'phone_nav_checked':''">深圳面授</span>
        </div>
        <div>
          <span>年级</span>
          <span>·</span>
          <span>学科</span>
          <span>·</span>
          <span>难度</span>
          <span>·</span>
          <span>
            <img src="@/assets/img/icon/xiala.png"
                 alt />
          </span>
        </div>
      </div>
      <div class="filter-container"
           v-if="phoneFilter || !isPhone">
        <div class="card_type">
          <div :style="online?'font-weight:600;color:rgba(255,255,255,1)':'color:rgba(255,255,255,0.6)'"
               @click="changeOnlineState('live')">线上直播</div>
          <div :style="!online?'font-weight:600;color:rgba(255,255,255,1)':'color:rgba(255,255,255,0.6)'"
               @click="changeOnlineState('offline')">深圳面授</div>
        </div>
        <div class="icon_sanjiao"
             :style="online?'left:22px':'left:132px'"></div>
        <div class="filter-items-container">
          <!-- <slot v-for="(item, index) in classListFilterItem">
            <div class="row"
                 v-bind:key="index"
                 :class="{
                'visible-row': !((!difficultState && isGrade) && item.name === 'difficult')
              }">
              <div class="col title">{{ item.title }}:</div>
              <div class="options">
                <slot v-for="(_item, _index) in item.option">
                  <div v-show="!(!difficultState && !isGrade && item.name === 'difficult' && _index < 8 && _index !== 0) && !(difficultState && isGrade && item.name === 'difficult' && _index > 4) && !(difficultState && !isGrade && item.name === 'difficult' && (_index > 7 || _index < 5) && _index !== 0)"
                       :data-name="item.name"
                       :data-value="_item.value"
                       :data-index="_index"
                       class="col option"
                       v-bind:key="_index"
                       v-bind:class="{ clicked: item.selectedIndex === _index  }"
                       @click="CommonfliterClick({ multiSelected: item.multiSelected, titleIndex: index, optionIndex: _index, typeChecked: item.selectedIndex === _index  })">{{ _item.label }}</div>
                </slot>
              </div>
            </div>
          </slot> -->
          <div class="new_nav">
            <div class="col_title">年级：</div>
            <div class="col_list">
            <div
            :class="gradeIndex===index?'col_option_checked':''"
            class="col_option" v-for="(item, index) in classListFilterItem"
            :key="index" @click="changeGradeSubject(index,'grade',item.title,gradeIndex===index)">
            {{ item.title }}</div>
            </div>
          </div>
          <div class="new_nav">
            <div class="col_title">学科：</div>
            <div class="col_list">
            <div
            :class="subjectIndex===index?'col_option_checked':''"
             class="col_option" v-for="(item, index) in subjectListFilterItem"
              :key="index"
               @click="changeGradeSubject(index,'subject',item.title,subjectIndex===index)">
               {{ item.title }}</div>
            </div>
          </div>
          <div class="new_nav" v-if="difficultListFilterItem.length>0">
            <div class="col_title">难度：</div>
            <div class="col_list">
            <div
            :class="difficultIndex===index?'col_option_checked':''"
             class="col_option" v-for="(item, index) in difficultListFilterItem"
             :zzc="item.url"
              :key="index" @click="changeGradeSubject(index,'difficult',item.label,difficultIndex===index,item.url)">
              {{ item.label }}</div>
            </div>
          </div>
        </div>
        <div class="phone-botton-area">
          <el-button class="reset"
                     @click="reset()">重置</el-button>
          <el-button class="confirm"
                     @click="confirm()">确定</el-button>
        </div>
        <div class="clear:both"></div>
      </div>
      <!-- 课程 -->
      <div v-if="classrightLabel === 'live'">
        <div class="live_titletext"
             v-if="ClassCardInfoup.length != 0&&textloading">系统班</div>
        <div class="class-list"
             v-if="!!ClassCardInfoup && ClassCardInfoup.length != 0"
             v-loading="loading"
             element-loading-text="拼命加载中">
          <div class="card"
               v-for="(item, index) in ClassCardInfoup"
               v-bind:key="index"
               @click="nextPage(item)">
            <ClassCard :index="index"
                       :clickType="1"
                       :classType="item.module"
                       :title="String(item.title)"
                       :classStatus="item.classStatus"
                       :subject="item.subject"
                       :date="item.date"
                       :classProcess="item.classProcess"
                       :time="item.time"
                       :position="item.position"
                       :price="item.price"
                       :class_id="item.id"
                       :realPrice="item.realPrice"
                       :ComponentsStyle="0"
                       :groupState="item.groupState"
                       :groupPrice="item.groupPrice"
                       :classLabel="classrightLabel"
                       :teacherList="item.teacher"
                       :subTitle="String(item.subTitle)"
                       :subSum="item.subSum"
                       :virtual_price="item.virtual_price"
                       :isLianbao="item.isLianbao"
                       :goodsId="item.goods_id"
                       :carState="item.shoppingCarState"
                       :isShowShoppingCar="item.isShowShoppingCar" />
          </div>
        </div>
        <div class="live_titletext"
             v-if="ClassCardInfodown.length != 0&&textloading">专题班</div>
        <div class="class-list"
             v-if="!!ClassCardInfodown && ClassCardInfodown.length != 0"
             v-loading="loading"
             element-loading-text="拼命加载中">
          <div class="card"
               v-for="(item, index) in ClassCardInfodown"
               v-bind:key="index"
               @click="nextPage(item)">
            <ClassCard :index="index"
                       :clickType="2"
                       :classType="item.module"
                       :title="String(item.title)"
                       :classStatus="item.classStatus"
                       :subject="item.subject"
                       :date="item.date"
                       :class_id="item.id"
                       :classProcess="item.classProcess"
                       :time="item.time"
                       :position="item.position"
                       :price="item.price"
                       :realPrice="item.realPrice"
                       :ComponentsStyle="0"
                       :groupState="item.groupState"
                       :groupPrice="item.groupPrice"
                       :classLabel="classrightLabel"
                       :teacherList="item.teacher"
                       :subTitle="String(item.subTitle)"
                       :subSum="item.subSum"
                       :virtual_price="item.virtual_price"
                       :isLianbao="item.isLianbao"
                       :carState="item.shoppingCarState"
                       :isShowShoppingCar="item.isShowShoppingCar"
                       :goodsId="item.goods_id" />
          </div>
        </div>
        <div class="class-list-empty"
             v-if="ClassCardInfodown.length==0 && ClassCardInfoup.length == 0">
          <div class="not-found-container">
            <div class="img">
              <img src="@/assets/img/notFound@2x.png"
                   alt />
            </div>
            <div class="tips">暂无课程，请更换筛选条件</div>
          </div>
        </div>
      </div>
      <div v-if="classrightLabel === 'offline'">
        <div class="class-list"
             v-if="!!ClassCardInfo && ClassCardInfo.length != 0"
             v-loading="loading"
             element-loading-text="拼命加载中">
          <div class="card"
               v-for="(item, index) in ClassCardInfo"
               v-bind:key="index"
               @click="nextPage(item)">
            <ClassCard :index="index"
                       :clickType="3"
                       :classType="item.module"
                       :title="String(item.title)"
                       :classStatus="item.classStatus"
                       :subject="item.subject"
                       :date="item.date"
                       :classProcess="item.classProcess"
                       :time="item.time"
                       :position="item.position"
                       :price="item.price"
                       :class_id="item.id"
                       :realPrice="item.realPrice"
                       :ComponentsStyle="0"
                       :groupState="item.groupState"
                       :groupPrice="item.groupPrice"
                       :classLabel="classrightLabel"
                       :teacherList="item.teacher"
                       :subTitle="String(item.subTitle)"
                       :subSum="item.subSum"
                       :virtual_price="item.virtual_price"
                       :carState="item.shoppingCarState"
                       :goodsId="item.goods_id"
                       :isShowShoppingCar="item.isShowShoppingCar"
                       :isAllPlayBackClass="item.isAllPlayBackClass"
                       :isLianbao="item.isLianbao" />
          </div>
        </div>
        <div class="class-list-empty"
             v-if="!ClassCardInfo || ClassCardInfo.length == 0">
          <div class="not-found-container">
            <div class="img">
              <img src="@/assets/img/notFound@2x.png"
                   alt />
            </div>
            <div class="tips">暂无课程，请更换筛选条件</div>
          </div>
        </div>
      </div>
      <div class="infinite-scroll"
           v-show="scorlloading">
        <span class="infinite-scroll-text">{{tip}}</span>
      </div>
      <div class="class-pagination"
           v-if="!!ClassCardInfo && ClassCardInfo.length != 0">
        <!-- <el-pagination
          layout="prev, pager, next"
          @current-change="pageChange"
          :page-count="totalPage"
        ></el-pagination>-->
      </div>
    </div>
    <!-- <Lianbao v-if="showLianbao"
             :goods-id-props="goods_id"
             mode-type="live"
             :courses-in-cart-props="[]"
             :closeCB="closeLianBaoModal"
             @lianbao-jiesuan="lianbaoJiesuan"
             @addcart-callback="addCart"></Lianbao> -->
    <JoinUpNow ref="JoinUpNow"
               :classInfo="cardInfo"></JoinUpNow>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import utils from '@/utils/utils'
import filters from '@/utils/filters'
import { LOGIN_TYPE } from '@/utils/constants'
import ClassCard from '@/components/ClassCard'
import JoinUpNow from '@/components/JoinUpNow'
// import Lianbao from '@/components/LianBaoModal'
import { mapState, mapActions } from 'vuex'
export default {
  data: function () {
    return {
      selectedType: 'classList',
      phoneFilter: false,
      loading: false,
      textloading: false,
      currentPage: 1,
      totalPage: 0,
      screenWidth: document.documentElement.clientWidth,
      isPhone: false,
      classListFilterItem: [],
      classListFilterIndex: 0,
      subjectListFilterIndex: 0,
      difficultListFilterIndex: 0,
      ClassCardInfo: [],
      ClassCardInfoup: [],
      ClassCardInfodown: [],
      online: true, // 线上线下样式切换
      classrightLabel: 'live',
      difficultState: false,
      isGrade: true,
      onPullDown: false, // 下拉加载
      isEnd: true, // 下拉加载
      tip: '',
      scorlloading: false,
      phoneClassType: 'live',
      showLianbao: false,
      goods_id: 0,
      cardInfo: {
        goods_id: 0,
        class_id: 0
      },
      cacheAddCart: {},
      gradeIndex: 0,
      subjectIndex: 0,
      difficultIndex: 0,
      subjectText: '',
      difficultText: ''
    }
  },
  name: 'CourseList',
  components: {
    ClassCard, JoinUpNow
  },
  mounted () {
    const _this = this
    window.onresize = function () {
      _this.screenWidth = document.documentElement.clientWidth
    }
    window.addEventListener('scroll', this.scroll, true) // 监听（绑定）滚轮滚动事件
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions(['getUserInfo', 'addCar']),
    addCart ({ goodsIds, goodsType }) {
      this.addCar({
        goodsIds,
        goodsType,
        callback: () => {
          this.addCartCallback()
        }
      })
    },
    addCartCallback () {
      if (this.cacheAddCart.clickType === 1) {
        this.ClassCardInfoup[this.cacheAddCart.index].shoppingCarState = false
      } else if (this.cacheAddCart.clickType === 2) {
        this.ClassCardInfodown[this.cacheAddCart.index].shoppingCarState = false
      } else if (this.cacheAddCart.clickType === 3) {
        this.ClassCardInfo[this.cacheAddCart.index].shoppingCarState = false
      }
      utils.ballAnimation(this.cacheAddCart.$target)
    },
    init () {
      this.checkPhone()
      const nowTime = parseInt(new Date().getTime() / 1000)
      api.getCourseLabel(nowTime).then(res => {
        this.handleResult(res.data)
      })
    },
    handleSearchParams (searchType) {
      const item = this.classListFilterItem
      if (searchType === 'grade') {
        return item[this.gradeIndex].value
      } else if (searchType === 'subject') {
        return item[this.gradeIndex].subject[this.subjectIndex].value
      } else {
        const difficultType = this.online ? 'live_difficult' : 'offlice_difficult' // eslint-disable-line no-unused-vars
        const difficultItem = item[this.gradeIndex].subject[this.subjectIndex][difficultType]
        return difficultItem.length > 0 ? difficultItem[this.difficultIndex].value : ''
      }
    },
    goLogin () {
      this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
        this.getUserInfo().then(_ => {
          this.$parent.init()
        })
      })
    },
    closeLianBaoModal () {
      this.showLianbao = false
    },
    showLianBao ($target, index, clickType) {
      this.cacheAddCart = { $target, index, clickType }
      this.showLianbao = true
    },
    lianbaoJiesuan () {
      const classType = this.classrightLabel === 'live' ? 'live' : 'nolive'
      this.$refs.JoinUpNow.goConfirm(classType, 2, this.cardInfo.class_id)
    },
    scroll () {
      var that = this
      // scrollTop 滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop + document.body.scrollTop
      // windowHeight 可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      // scrollHeight 滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (
        scrollTop + windowHeight + 500 > scrollHeight &&
        that.onPullDown === true &&
        that.isEnd === true
      ) {
        that.onPullDown = false
        // 加载数据
        that.currentPage = that.currentPage + 1
        if (this.classrightLabel === 'live') {
          this.getSystemLiveList()
        } else if (this.classrightLabel === 'offline') {
          this.getClassList()
        }
      }
    },
    CommonfliterClick (e) {
      if (e.typeChecked) {
        return false
      }
      this.currentPage = 1
      if (this.classrightLabel === 'offline') {
        this.fliterClick(e)
      } else if (this.classrightLabel === 'live') {
        this.LivefliterClick(e)
      }
    },
    // 点击年级 改变学科和难度
    changeGradeSubject (index, type, navText, checked, url) {
      if (checked) {
        return false
      } else if (url) {
        window.open(url)
        return false
      }
      if (type === 'grade') {
        this.gradeIndex = index
        this.difficultIndex = 0
        this.difficultText = ''
        const item = this.classListFilterItem[index].subject
        if (item.length === 0 ||
        (!item[this.subjectIndex]) ||
        (item[this.subjectIndex]).title !== this.subjectText) {
          this.subjectIndex = 0
          this.subjectText = ''
        }
      } else if (type === 'subject') {
        this.subjectIndex = index
        this.subjectText = navText
        const difficultType = this.online ? 'live_difficult' : 'offlice_difficult' // eslint-disable-line no-unused-vars
        const item = this.classListFilterItem[this.gradeIndex].subject[this.subjectIndex][difficultType]
        if (item.length === 0 ||
         !item[this.difficultIndex] ||
         item[this.difficultIndex].label !== this.difficultText) {
          this.difficultIndex = 0
          this.difficultText = ''
        }
      } else {
        this.difficultText = navText
        this.difficultIndex = index
      }
      this.currentPage = 1
      if (this.classrightLabel === 'offline') {
        this.ClassCardInfo = []
        !this.phoneFilter && this.getClassList()
      } else if (this.classrightLabel === 'live') {
        this.ClassCardInfoup = []
        this.ClassCardInfodown = []
        !this.phoneFilter && this.getLiveList()
        !this.phoneFilter && this.getSystemLiveList()
      }
    },
    handleResult (res) {
      this.classListFilterItem = res
      // this.getClassList()
      this.getLiveList()
      this.getSystemLiveList()
      if (window.location.href.indexOf('?') > -1) {
        const hashSearch = window.location.href.split('?')[1].split('=')[1]
        if (hashSearch === 'offline') {
          this.changeOnlineState('offline')
        }
      }
    },
    checkPhone () {
      const width = document.body.clientWidth
      if (width < 767) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    selected (e) {
      this.selectedType = e
    },
    fliterClick (e) {
      this.ClassCardInfo = []
      if (e.titleIndex === 0) {
        this.isGrade = e.optionIndex <= 2
        this.classListFilterItem[2].selectedIndex = 0
      }
      let check = null
      if (e.multiSelected) {
        if (e.optionIndex === 0) {
          this.$set(this.classListFilterItem[e.titleIndex], 'selectedArry', [
            0
          ])
          check = '选中'
        } else {
          // 选中效果
          const selectedArry = this.classListFilterItem[e.titleIndex]
            .selectedArry
          // 取消选中
          if (selectedArry.includes(e.optionIndex)) {
            const idx = selectedArry.findIndex(item => item === e.optionIndex)
            selectedArry.splice(idx, 1)
            selectedArry.length === 0 && selectedArry.push(0)
            check = '取消选中'
          } else {
            selectedArry.push(e.optionIndex)
            selectedArry.includes(0) &&
              selectedArry.splice(selectedArry.indexOf(0), 1)
            check = '选中'
          }

          this.$set(
            this.classListFilterItem[e.titleIndex],
            'selectedArry',
            selectedArry
          )
        }
      } else {
        check =
          this.classListFilterItem[e.titleIndex].selectedIndex === e.optionIndex
            ? '取消选中'
            : '选中'
      }
      // if (e.titleIndex === 0 && e.optionIndex === 1) {
      //   this.$set(this.classListFilterItem[1], 'selectedIndex', 3)
      // }
      this.$set(
        this.classListFilterItem[e.titleIndex],
        'selectedIndex',
        e.optionIndex
      )
      this.zhuGeEventTrack(this.zhugeEvents.HOME_PAGE.SELECT_CLICK, [
        this.classListFilterItem[e.titleIndex].title,
        check,
        this.classListFilterItem[e.titleIndex].option[e.optionIndex].label
      ])
      !this.phoneFilter && this.getClassList()
    },
    LivefliterClick (e) {
      this.ClassCardInfoup = []
      this.ClassCardInfodown = []
      if (e.titleIndex === 0) {
        this.isGrade = e.optionIndex <= 2
        this.classListFilterItem[2].selectedIndex = 0
      } else if (e.titleIndex === 2 && e.optionIndex === 10) {
        window.open(process.env.VUE_APP_ZHIXIN_URL + '/#recommend')
        return false
      }
      let check = null
      if (e.multiSelected) {
        if (e.optionIndex === 0) {
          this.$set(this.classListFilterItem[e.titleIndex], 'selectedArry', [
            0
          ])
          check = '选中'
        } else {
          // 选中效果
          const selectedArry = this.classListFilterItem[e.titleIndex]
            .selectedArry
          // 取消选中
          if (selectedArry.includes(e.optionIndex)) {
            const idx = selectedArry.findIndex(item => item === e.optionIndex)
            selectedArry.splice(idx, 1)
            selectedArry.length === 0 && selectedArry.push(0)
            check = '取消选中'
          } else {
            selectedArry.push(e.optionIndex)
            selectedArry.includes(0) &&
              selectedArry.splice(selectedArry.indexOf(0), 1)
            check = '选中'
          }

          this.$set(
            this.classListFilterItem[e.titleIndex],
            'selectedArry',
            selectedArry
          )
        }
      } else {
        check =
          this.classListFilterItem[e.titleIndex].selectedIndex === e.optionIndex
            ? '取消选中'
            : '选中'
      }
      // if (e.titleIndex === 0 && e.optionIndex === 1) {
      //   this.$set(this.classListFilterItem[1], 'selectedIndex', 3)
      // }
      this.$set(
        this.classListFilterItem[e.titleIndex],
        'selectedIndex',
        e.optionIndex
      )
      this.zhuGeEventTrack(this.zhugeEvents.HOME_PAGE.SELECT_CLICK, [
        this.classListFilterItem[e.titleIndex].title,
        check,
        this.classListFilterItem[e.titleIndex].option[e.optionIndex].label
      ])
      !this.phoneFilter && this.getLiveList()
      !this.phoneFilter && this.getSystemLiveList()
    },
    triggerPhoneFilter () {
      this.phoneFilter = !this.phoneFilter
    },
    nextPage (obj) {
      this.$router.push({
        name: 'ClassDetail',
        params: { classId: obj.id, classType: this.classrightLabel }
      })
      // const routeUrl = this.$router.resolve({
      //   name: 'ClassDetail',
      //   params: { classId: id, classType: this.classrightLabel }
      // })
      // window.open(routeUrl.href, '_blank')
      this.zhuGeEventTrack(this.zhugeEvents.COURSE_CARD_CLICK, [
        this.classrightLabel === 'live' ? '直播课' : '面授课',
        this.classrightLabel === 'live' ? obj.type : filters.handleClassType(obj.type),
        obj.course_belong,
        obj.id,
        obj.title,
        obj.classCardStatus,
        obj.isLianbao ? '联报' : obj.isGroup ? '拼团' : '无'
      ])
    },
    getClassList (page) {
      // if (page) {
      //   this.currentPage = page
      // } else {
      //   this.currentPage = 1
      // }
      this.loading = true
      // const list = this.classListFilterItem
      const params = {
        // current_page: this.currentPage,
        current_page: this.currentPage,
        grade: this.handleSearchParams('grade'),
        subject_type: this.handleSearchParams('subject'),
        difficult: this.handleSearchParams('difficult'),
        course_belong: '质心灵动量'
      }
      api
        .getClassList(params)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data.data || []
            const nowTime = parseInt(new Date().getTime() / 1000)
            this.totalPage = r.data.data.total_pages
            // this.ClassCardInfo = []
            this.classrightLabel = 'offline'
            let result = [] // eslint-disable-line no-unused-vars
            result = item.map(item => {
              // 拼装状态
              const quota = { total: item.quota, ordered: item.ordered }
              const orderBeginAt = item.order_begin_at
              const classStatus = utils.calcuQuotaText(
                quota,
                orderBeginAt,
                item.pre_days
              )
              let index = item.subs_info.filter(
                _item => _item.begin_at < nowTime
              ).length
              index = index === -1 ? 0 : index
              const subject = item.subject_type.includes('PHY')
                ? '物'
                : item.subject_type.includes('BIO')
                  ? '生'
                  : item.subject_type.includes('CHEM')
                    ? '化'
                    : item.subject_type.includes('MATH')
                      ? '数'
                      : ''
              const module = item.subject_type.includes('PHY')
                ? '物理'
                : item.subject_type.includes('BIO')
                  ? '生物'
                  : item.subject_type.includes('CHEM')
                    ? '化学'
                    : item.subject_type.includes('MATH')
                      ? '数学'
                      : ''
              const type =
                item.time_cycle !== '' ? JSON.parse(item.time_cycle) : ''
              const time =
                item.cycle === '无周期'
                  ? item.cycle
                  : item.cycle +
                  type
                    .map(_item => {
                      return _item.begin_at + '-' + _item.end_at
                    })
                    .join(' ')
              let groupState = item.activity_type === 1 ? 1 : 2
              const groupPrice =
                item.activity_type === 1
                  ? item.activity_info.group_price / 100
                  : -1
              const groupEndTime =
                item.activity_info === null
                  ? -1
                  : item.activity_info.group_end_time
              const subSum = item.subs_info.length
              if (nowTime > groupEndTime) {
                groupState = 2
              }
              const isAllPlayBackClass = nowTime >= item.subs_info[item.subs_info.length - 1].begin_at
              let isShowShoppingCar
              if (isAllPlayBackClass) {
                isShowShoppingCar = 1
              } else {
                isShowShoppingCar = classStatus.orderedText === '报名未开始' || classStatus.orderedText === '名额已满' || item.subs_info[item.subs_info.length - 1].begin_at - 1800 < nowTime || item.real_price / 100 <= 0 ? 2 : 1
              }
              const isLianbao = item.unions_info.some(element => {
                return element.end_at > nowTime
              })
              // const isShowShoppingCar = classStatus.orderedText === '报名未开始' || classStatus.orderedText === '名额已满' || item.subs_info[item.subs_info.length - 1].begin_at - 1800 < nowTime || item.real_price / 100 <= 0 ? 2 : 1
              return {
                id: item.class_id,
                classType:
                  item.sub_type === 3
                    ? '同步班'
                    : item.sub_type === 4
                      ? '强基班'
                      : '竞赛班',
                module,
                title: item.title,
                classStatus: {
                  text: classStatus.orderedText,
                  style: classStatus.orderedStatus
                },
                subject,
                date:
                  moment.unix(item.begin_at).format('YYYY.MM.DD') +
                  '-' +
                  moment.unix(item.end_at).format('YYYY.MM.DD'),
                classProcess: `已进行${index}/${item.subs_info.length}`,
                time,
                position: item.city,
                teacher: item.teachers_info,
                price: item.price / 100,
                realPrice: item.real_price / 100,
                groupState,
                groupPrice,
                subSum,
                virtual_price: null,
                activity_type: item.activity_type,
                activity_info: item.activity_info,
                goods_id: Number(item.goods_id),
                shoppingCarState: !item.cart_exist,
                isShowShoppingCar,
                isAllPlayBackClass,
                isLianbao,
                type: item.sub_type,
                course_belong: item.course_belong,
                classCardStatus: nowTime < item.begin_at
                  ? '未开始'
                  : nowTime > item.end_at
                    ? '已结束'
                    : '进行中',
                isGroup: item.activity_info !== null && item.activity_info.group_set === 1 &&
              (item.activity_info.group_end_time === 0 || nowTime < item.activity_info.group_end_time)
              }
            })
            this.ClassCardInfo = this.ClassCardInfo.concat(result)
            if (item.length > 0) {
              this.isEnd = true
            } else {
              this.isEnd = false
            }
            this.$nextTick(() => {
              this.onPullDown = true
            })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
          this.tips = '连接失败，请稍后重试'
          this.scorlloading = true
        })
      this.loading = false
    },
    getLiveList (page) {
      this.loading = true
      // const list = this.classListFilterItem
      this.classrightLabel = 'live'
      const num = 6
      const params = {
        type: '系统课',
        // current_page: this.currentPage,
        grade: this.handleSearchParams('grade'),
        subject_type: this.handleSearchParams('subject'),
        difficult: this.handleSearchParams('difficult'),
        course_belong: '质心灵动量',
        num
      }
      api
        .getLiveList(params)
        .then(r => {
          if (r.data.code === 1) {
            this.textloading = true
            const item = r.data.items || []
            const nowTime = parseInt(new Date().getTime() / 1000)
            this.totalPage = r.data.data.total_pages
            let result = [] // eslint-disable-line no-unused-vars
            result = item.map(item => {
              // 拼装状态
              // const quota = { total: item.quota, ordered: item.ordered }
              // const orderBeginAt = item.order_begin_at
              // const classStatus = utils.calcuQuotaText(quota, orderBeginAt, item.pre_days)
              let index = item.subs_info.filter(
                _item => _item.begin_at < nowTime
              ).length
              index = index === -1 ? 0 : index
              const subject = item.subject_type.includes('PHY')
                ? '物'
                : item.subject_type.includes('BIO')
                  ? '生'
                  : item.subject_type.includes('CHEM')
                    ? '化'
                    : item.subject_type.includes('MATH')
                      ? '数'
                      : ''
              const module = item.subject_type.includes('PHY')
                ? '物理'
                : item.subject_type.includes('BIO')
                  ? '生物'
                  : item.subject_type.includes('CHEM')
                    ? '化学'
                    : item.subject_type.includes('MATH')
                      ? '数学'
                      : ''
              // const type = item.time_cycle !== '' ? JSON.parse(item.time_cycle) : ''
              // const time = item.cycle === '无周期' ? item.cycle : item.cycle + type.map(_item => { return _item.begin_at + '-' + _item.end_at }).join(' ')
              let groupState = item.activity_type === 1 ? 1 : 2
              const groupPrice =
                item.activity_type === 1
                  ? item.activity_info.group_price / 100
                  : -1
              // const groupEndTime =
              //   item.activity_info === null
              //     ? -1
              //     : item.activity_info.group_end_time
              const subSum = item.subs_info.length
              const type = item.type
              // if (item.group_setting === null && nowTime > groupEndTime) {
              //   groupState = 2
              // }
              // 判断团购
              // 判断团购
              if (item.group_setting) {
                item.group_set = item.group_setting.group_set
                item.group_end_time = item.group_setting.group_end_time
                item.group_price = item.group_setting.group_price
              }
              if (item.group_end_time) {
                item.groupBuy = item.group_set === 1 && new Date().getTime() / 1000 - item.group_end_time < 0
              } else {
                item.groupBuy = item.group_set === 1
              }
              if (item.groupBuy) {
                groupState = 1
              } else {
                groupState = 2
              }
              const isShowShoppingCar = 1
              const isLianbao = item.unions_info.some(element => {
                return element.end_at > nowTime
              })
              return {
                id: item.class_id,
                // classType: item.sub_type === 3 ? '同步班' : item.sub_type === 4 ? '强基班' : '竞赛班',
                module,
                title: item.subject,
                // classStatus: { text: classStatus.orderedText, style: classStatus.orderedStatus },
                subject,
                date:
                  moment.unix(item.begin_at).format('YYYY.MM.DD') +
                  '-' +
                  moment.unix(item.end_at).format('YYYY.MM.DD'),
                classProcess: `已进行${index}/${item.subs_info.length}`,
                // time,
                position: item.city,
                teacher: item.teachers_info,
                price: item.price / 100,
                realPrice: item.price / 100,
                groupState,
                groupPrice,
                subTitle: item.short_desp,
                subSum,
                type,
                virtual_price: item.virtual_price,
                activity_type: item.activity_type,
                activity_info: item.activity_info,
                goods_id: Number(item.goods_id),
                shoppingCarState: !item.cart_exist,
                isShowShoppingCar,
                isLianbao,
                course_belong: item.course_belong,
                classCardStatus: nowTime < item.begin_at
                  ? '未开始'
                  : nowTime > item.end_at
                    ? '已结束'
                    : '进行中',
                isGroup: item.activity_info !== null && item.activity_info.group_set === 1 &&
              (item.activity_info.group_end_time === 0 || nowTime < item.activity_info.group_end_time)
              }
            })
            this.ClassCardInfoup = this.ClassCardInfoup.concat(result)
            if (item.length > 0) {
              this.isEnd = true
            } else {
              this.isEnd = false
            }
            this.$nextTick(() => {
              this.onPullDown = true
            })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
          this.tips = '连接失败，请稍后重试'
          this.scorlloading = true
        })
      this.loading = false
    },
    getSystemLiveList (page) {
      this.loading = true
      // const list = this.classListFilterItem
      this.classrightLabel = 'live'
      const num = 12
      const params = {
        type: '专题课',
        page: this.currentPage,
        grade: this.handleSearchParams('grade'),
        subject_type: this.handleSearchParams('subject'),
        difficult: this.handleSearchParams('difficult'),
        course_belong: '质心灵动量',
        num
      }
      api
        .getLiveList(params)
        .then(r => {
          if (r.data.code === 1) {
            this.textloading = true
            const item = r.data.items || []
            const nowTime = parseInt(new Date().getTime() / 1000)
            this.totalPage = r.data.data.total_pages
            let result = [] // eslint-disable-line no-unused-vars
            result = item.map(item => {
              // 拼装状态
              // const quota = { total: item.quota, ordered: item.ordered }
              // const orderBeginAt = item.order_begin_at
              // const classStatus = utils.calcuQuotaText(quota, orderBeginAt, item.pre_days)
              let index = item.subs_info.filter(
                _item => _item.begin_at < nowTime
              ).length
              index = index === -1 ? 0 : index
              const subject = item.subject_type.includes('PHY')
                ? '物'
                : item.subject_type.includes('BIO')
                  ? '生'
                  : item.subject_type.includes('CHEM')
                    ? '化'
                    : item.subject_type.includes('MATH')
                      ? '数'
                      : ''
              const module = item.subject_type.includes('PHY')
                ? '物理'
                : item.subject_type.includes('BIO')
                  ? '生物'
                  : item.subject_type.includes('CHEM')
                    ? '化学'
                    : item.subject_type.includes('MATH')
                      ? '数学'
                      : ''
              // const type = item.time_cycle !== '' ? JSON.parse(item.time_cycle) : ''
              // const time = item.cycle === '无周期' ? item.cycle : item.cycle + type.map(_item => { return _item.begin_at + '-' + _item.end_at }).join(' ')
              let groupState = item.activity_type === 1 ? 1 : 2
              const groupPrice =
                item.activity_type === 1
                  ? item.activity_info.group_price / 100
                  : -1
              // const groupEndTime =
              //   item.activity_info === null
              //     ? -1
              //     : item.activity_info.group_end_time
              const subSum = item.subs_info.length
              const type = item.type
              // if (item.group_setting === null && nowTime > groupEndTime) {
              //   groupState = 2
              // }
              // 判断团购
              if (item.group_setting) {
                item.group_set = item.group_setting.group_set
                item.group_end_time = item.group_setting.group_end_time
                item.group_price = item.group_setting.group_price
              }
              if (item.group_end_time) {
                item.groupBuy = item.group_set === 1 && new Date().getTime() / 1000 - item.group_end_time < 0
              } else {
                item.groupBuy = item.group_set === 1
              }
              if (item.groupBuy) {
                groupState = 1
              } else {
                groupState = 2
              }
              const isShowShoppingCar = 1
              const isLianbao = item.unions_info.some(element => {
                return element.end_at > nowTime
              })
              return {
                id: item.class_id,
                // classType: item.sub_type === 3 ? '同步班' : item.sub_type === 4 ? '强基班' : '竞赛班',
                module,
                title: item.subject,
                // classStatus: { text: classStatus.orderedText, style: classStatus.orderedStatus },
                subject,
                date:
                  moment.unix(item.begin_at).format('YYYY.MM.DD') +
                  '-' +
                  moment.unix(item.end_at).format('YYYY.MM.DD'),
                classProcess: `已进行${index}/${item.subs_info.length}`,
                // time,
                position: item.city,
                teacher: item.teachers_info,
                price: item.price / 100,
                realPrice: item.price / 100,
                groupState,
                groupPrice,
                subTitle: item.short_desp,
                subSum,
                type,
                virtual_price: item.virtual_price,
                activity_type: item.activity_type,
                activity_info: item.activity_info,
                shoppingCarState: !item.cart_exist,
                goods_id: Number(item.goods_id),
                isShowShoppingCar,
                isLianbao,
                course_belong: item.course_belong,
                classCardStatus: nowTime < item.begin_at
                  ? '未开始'
                  : nowTime > item.end_at
                    ? '已结束'
                    : '进行中',
                isGroup: item.activity_info !== null && item.activity_info.group_set === 1 &&
              (item.activity_info.group_end_time === 0 || nowTime < item.activity_info.group_end_time)
              }
            })
            this.ClassCardInfodown = this.ClassCardInfodown.concat(result)
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
      this.loading = false
    },
    pageChange (e) {
      this.currentPage = e
      this.getClassList(e)
    },
    reset () {
      this.isGrade = true
      this.restNavData()
    },
    confirm () {
      this.currentPage = 1
      this.phoneFilter = false
      if (this.phoneClassType === 'live') {
        this.getLiveList()
        this.getSystemLiveList()
      } else if (this.phoneClassType === 'offline') {
        this.getClassList()
      }
      // this.getClassList()
    },
    // 重置导航数据
    restNavData () {
      this.gradeIndex = 0
      this.subjectIndex = 0
      this.difficultIndex = 0
      this.subjectText = ''
      this.difficultText = ''
    },
    changeOnlineState (OnlineState) {
      this.restNavData()
      // this.online = !this.online
      this.phoneClassType = OnlineState
      this.classrightLabel = OnlineState
      this.ClassCardInfo = []
      this.ClassCardInfoup = []
      this.ClassCardInfodown = []
      this.currentPage = 1
      if (OnlineState === 'live') {
        this.online = true
        this.difficultState = false
        this.getLiveList()
        this.getSystemLiveList()
      } else if (OnlineState === 'offline') {
        this.online = false
        this.difficultState = true
        this.getClassList()
      }
      const width = document.body.clientWidth
      if (width < 767) {
        this.phoneFilter = true
      }
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    }),
    subjectListFilterItem () {
      const classList = this.classListFilterItem
      const subjectList = classList.length > 0 ? classList[this.gradeIndex].subject : []
      return subjectList
    },
    difficultListFilterItem () {
      const difficultType = this.online ? 'live_difficult' : 'offlice_difficult' // eslint-disable-line no-unused-vars
      const classList = this.classListFilterItem
      return classList.length > 0 ? classList[this.gradeIndex].subject[this.subjectIndex][difficultType] : []
    }
  },
  watch: {
    screenWidth () {
      this.checkPhone()
    },
    '$route.path' (to, from) {
      if (to !== '/') {
        window.removeEventListener('scroll', this.scroll, true)
      } else {
        window.addEventListener('scroll', this.scroll, true) // 监听（绑定）滚轮滚动事件
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scroll, true)
  }
}
</script>

<style lang="scss" >
@import "@/assets/scss/_base.scss";
.phone {
  display: none;
}

.dis-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sub-header {
  display: flex;
  justify-content: space-between;
  .left-img {
    width: 324px;
    height: 118px;

    img {
      margin-top: 76px;
      width: 100%;
      height: 100%;
    }
  }

  .right-img {
    width: 379px;
    height: 70%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  height: 194px;
  background-color: #00c7bf;

  .title {
    margin-top: 58px;
    width: 208px;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
    color: #ffffff;
    letter-spacing: 1.5px;
    font-weight: 600;
  }

  .tab {
    display: flex;
    margin-top: 32px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    border: 1px #ffffff solid;
    border-radius: 4px 4px 4px 4px;

    .left-tab {
      width: 156px;
      height: 40px;
      cursor: pointer;
    }

    .right-tab {
      width: 156px;
      height: 40px;
      cursor: pointer;
    }

    .selected {
      background-color: #ffffff;
      color: #00c7bf;
    }
  }
}

#classList {
  display: flex;
  margin-top: 73px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  .phone-trigger {
    display: none;
  }
  .filter-container {
    width: 1140px;
    margin-top: -190px;
    position: relative;
    .phone-botton-area {
      display: none;
    }

    min-height: 138px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    .card_type {
      font-size: 18px;
      display: flex;
      position: absolute;
      top: -44px;
      div {
        cursor: pointer;
      }
    }
    .card_type div:nth-child(1) {
      margin-right: 40px;
    }
    .icon_sanjiao {
      width: 0;
      height: 0;
      border: 12px solid;
      border-color: transparent transparent white;
      position: absolute;
      top: -23px;
      left: 22px;
    }
    .filter-items-container {
      margin: 29px 0 29px 40px;
      display: flex;
      flex-direction: column;
      .new_nav{
        display: flex;
        margin-top: 20px;
        .col_title{
          width: 45px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #2c2d2e;
          line-height: 20px;
          margin-right: 33px;
        }
        .col_list{
          display: flex;
          flex-wrap: wrap;
          flex:1;
          .col_option{
          margin-right: 27px;
          height: 20px;
          font-size: 14px;
          line-height: 20px;
          color: rgba(51,51,51,.6);
          margin-bottom: 4px;
          cursor: pointer;
          }
          .col_option_checked{
              color: #00c7bf;
            }
        }
      }
      .new_nav:nth-child(1){
        margin-top: 0px;
      }
    }
    .row + .row {
      margin-top: 18px;
    }
    .row {
      display: flex;
      visibility: hidden;
      &.visible-row {
        visibility: visible;
      }
      .title {
        width: 36px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(44, 45, 46, 1);
        line-height: 20px;
        margin-right: 33px;
      }

      .options {
        display: flex;
        cursor: pointer;
        width: 750px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(44, 45, 46, 1);
        margin-right: 40px;

        .option {
          display: flex;
          margin-right: 27px;
          color: rgba(51, 51, 51, 0.6);
          &.clicked {
            font-weight: 600;
            color: $brand-success;
          }
        }
      }

      .clicked {
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 199, 191, 1);
        line-height: 20px;
      }
    }
  }
  .live_titletext {
    font-size: 24px;
    margin-top: 40px;
    font-weight: 600;
  }
  .class-list {
    width: 1140px;
    display: flex;
    flex-wrap: wrap;
    .card {
      width: 30%;
      margin-top: 24px;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 40px 30px -30px #dbe3e7;
      }
    }
    .card:not(:nth-child(3n)) {
      margin-right: calc(11% / 3);
    }
  }

  .class-pagination {
    margin: 36px 0 36px 0;

    .el-pagination {
      .el-pager li {
        background-color: #eeeff2;
      }

      button {
        background-color: #eeeff2;
      }
    }
  }
}

.class-list-empty {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;

  .not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .img {
      width: 176px;
      height: 176px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .tips {
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 0.5);
      line-height: 28px;
      letter-spacing: 1px;
    }
  }
}
// 平板适配
@media (min-width: 768px) and (max-width: 1372px) {
  #classList {
    .filter-container {
      width: 760px;
    }
    .class-list {
      width: 760px;
      display: flex;
      flex-wrap: wrap;
      .card {
        width: 40%;
        margin-top: 24px;
      }
      .card:not(:nth-child(2n)) {
        margin-right: calc(23% / 2);
      }
    }
  }
}
// 手机适配
@media (min-width: 300px) and (max-width: 767px) {
  .phone {
    display: unset;
  }
  // !推送前删除
  #zhixin-nav {
    display: none;
  }
  .banner .banner-contaier .phone-logo .icon img {
    width: 14px;
    position: relative;
    top: 9px;
  }
  .sub-header {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    .side-bar-trigger {
      display: none;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 16px;
      width: 30px;
      height: 30px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .tab {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);

      .left-tab {
        width: 120px;
      }

      .right-tab {
        width: 120px;
      }

      .selected {
        font-size: 14px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        border-bottom: 3px
          linear-gradient(
            308deg,
            rgba(56, 211, 205, 1) 0%,
            rgba(0, 199, 191, 1) 100%
          )
          solid;
      }
    }

    .left-img {
      display: none;
    }

    .container {
      .title {
        display: none;
      }
    }

    .right-img {
      display: none;
    }
  }
  #classList {
    margin-top: 0;
    margin-top: 39px;
    .live_titletext {
      margin-top: 5px;
    }
    .phone-trigger {
      display: unset;
      position: absolute;
      top: 76px;
      width: 100%;
      height: 38px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #33333360;
      z-index: 2;
      justify-content: space-around;
      div {
        margin-left: 16px;
      }

      span {
        margin-right: 8px;

        img {
          width: 10px;
          height: 10px;
        }
      }
      .phone_navcheck {
        position: relative;
        color: rgba(51, 51, 51, 0.6);
      }
      .phone_nav_checked {
        color: rgba(0, 199, 191, 1);
      }
      .phone_nav_checked:after {
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
        height: 3px;
        width: 16px;
        content: "";
        background: #00c7bf;
        top: 23px;
      }
    }

    .filter-container {
      width: 100%;
      height: auto;
      z-index: 9;
      position: absolute;
      top: 302px;

      .filter-items-container {
        .new_nav{
          display: inline-block;
          margin-top: 20px;
          .col_title{
            width: 45px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #2c2d2e;
            line-height: 20px;
            margin-right: 33px;
          }
          .col_list{
            display: flex;
            flex-wrap: wrap;
            .col_option{
              margin-right: 27px;
              height: 20px;
              font-size: 14px;
              line-height: 20px;
              color: rgba(51,51,51,.6);
              background: rgba(51,51,51,.06);
              border-radius: 4px;
              padding: 0px 8px;
              margin-right: 8px;
              margin-bottom: 8px;
              height: 29px;
              line-height: 29px;
            }
            .col_option_checked{
              color: #00c7bf;
              background: rgba(10,201,193,.16);
              border-radius: 4px;
              border: 1px solid #0ac9c1;
            }
          }
        }
        .new_nav:nth-child(1){
          margin-top: 0px;
        }
        .title {
          font-size: 13px;
          font-weight: 400;
          color: rgba(44, 45, 46, 1);
        }
        text-align: center;
        margin: 0 0 0 16px;
        // height: 174px;
        // justify-content: space-around;

        .row {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .options {
            display: flex;
            width: auto;
            height: auto;
            // flex-wrap: wrap;
            .option {
              display: flex;
              justify-content: center;
              align-items: center;
              // width: 80px;
              height: 29px;
              background: rgba(51, 51, 51, 0.06);
              margin: 0;
              border-radius: 4px;
              margin-right: 8px;
              margin-bottom: 8px;
              padding: 0px 8px;
              &.clicked {
                background: rgba(10, 201, 193, 0.16);
                border-radius: 4px;
                border: 1px solid rgba(10, 201, 193, 1);
              }
            }
            flex-wrap: wrap;
          }
        }
      }

      .phone-botton-area {
        height: 66px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .reset {
          width: 124px;
          height: 34px;
          background: rgba(222, 222, 222, 1);
          border-radius: 4px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }

        .confirm {
          width: 208px;
          height: 34px;
          background: linear-gradient(
            308deg,
            rgba(56, 211, 205, 1) 0%,
            rgba(0, 199, 191, 1) 100%
          );
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    .class-list {
      width: 100%;
      display: flex;
      justify-content: center;

      .card {
        width: 100%;
        margin-top: 15px;
        display: flex;
        justify-content: center;
      }

      .card:not(:nth-child(3n)) {
        margin-right: 0;
      }
    }
  }
}
</style>
